import { create } from 'zustand'
import { getToken } from '../lib/apiFetch'

export const STATUS = {
  NORMAL: 'normal',
  WARN:   'warn',
  ALERT:  'alert',
  IDLE:   'idle',
}

export const SYMBOLS = {
  IPM:           'ipm',
  NET:           'net',
  POT_CHECK:     'pot_check',
  FILTER_CHANGE: 'filter_change',
  DEFOLIATION:   'defoliation',
  TRANSFER:      'transfer',
  HARVEST_READY: 'harvest_ready',
  MODE_CHANGE:   'mode_change',
  SUPPLY_READY:  'supply_ready',
  ISSUE:         'issue',
}

export const MODES = {
  OFF:  'off',
  AUTO: 'auto',
  CROP: 'crop',
  FILL: 'fill',
}

// ── Offline-first seed data ────────────────────────────────────────────────
const initialRooms = [
  { id: 'VEG1', name: 'VEG 1', type: 'veg',     mode: MODES.CROP, stage: 'Veg Day 18',  status: STATUS.NORMAL, symbols: [], overlays: [], flags: [], reEntryExpiresAt: null },
  { id: 'VEG2', name: 'VEG 2', type: 'veg',     mode: MODES.CROP, stage: 'Veg Day 10',  status: STATUS.WARN,   symbols: [SYMBOLS.IPM], overlays: [], flags: [], reEntryExpiresAt: null },
  { id: 'VEG3', name: 'VEG 3', type: 'veg',     mode: MODES.CROP, stage: 'Veg Day 24',  status: STATUS.NORMAL, symbols: [SYMBOLS.TRANSFER], overlays: [], flags: [], reEntryExpiresAt: null },
  { id: 'VEG4', name: 'VEG 4', type: 'veg',     mode: MODES.CROP, stage: 'Veg Day 30',  status: STATUS.NORMAL, symbols: [], overlays: [], flags: [], reEntryExpiresAt: null },
  { id: 'F9',  name: 'F9',  type: 'flower', mode: MODES.CROP, stage: 'Flower Day 7',  status: STATUS.NORMAL, symbols: [], overlays: [], flags: [], reEntryExpiresAt: null },
  { id: 'F8',  name: 'F8',  type: 'flower', mode: MODES.CROP, stage: 'Flower Day 14', status: STATUS.WARN,   symbols: [SYMBOLS.IPM, SYMBOLS.ISSUE], overlays: [], flags: [], reEntryExpiresAt: null },
  { id: 'F7',  name: 'F7',  type: 'flower', mode: MODES.CROP, stage: 'Flower Day 21', status: STATUS.NORMAL, symbols: [SYMBOLS.DEFOLIATION], overlays: [], flags: [], reEntryExpiresAt: null },
  { id: 'F6',  name: 'F6',  type: 'flower', mode: MODES.CROP, stage: 'Flower Day 28', status: STATUS.NORMAL, symbols: [], overlays: [], flags: [], reEntryExpiresAt: null },
  { id: 'F5',  name: 'F5',  type: 'flower', mode: MODES.FILL, stage: 'Flower Day 35', status: STATUS.ALERT,  symbols: [SYMBOLS.ISSUE], overlays: [], flags: [], reEntryExpiresAt: null },
  { id: 'F14', name: 'F14', type: 'flower', mode: MODES.CROP, stage: 'Flower Day 42', status: STATUS.NORMAL, symbols: [SYMBOLS.HARVEST_READY], overlays: [], flags: [], reEntryExpiresAt: null },
  { id: 'F13', name: 'F13', type: 'flower', mode: MODES.CROP, stage: 'Flower Day 49', status: STATUS.NORMAL, symbols: [], overlays: [], flags: [], reEntryExpiresAt: null },
  { id: 'F12', name: 'F12', type: 'flower', mode: MODES.CROP, stage: 'Flower Day 56', status: STATUS.NORMAL, symbols: [SYMBOLS.SUPPLY_READY], overlays: [], flags: [], reEntryExpiresAt: null },
  { id: 'F11', name: 'F11', type: 'flower', mode: MODES.FILL, stage: 'Harvest Week',  status: STATUS.NORMAL, symbols: [], overlays: [], flags: [], reEntryExpiresAt: null },
  { id: 'F10', name: 'F10', type: 'flower', mode: MODES.CROP, stage: 'Flower Day 7',  status: STATUS.WARN,   symbols: [SYMBOLS.MODE_CHANGE], overlays: [], flags: [], reEntryExpiresAt: null },
  { id: 'F17', name: 'F17', type: 'flower', mode: MODES.CROP, stage: 'Flower Day 14', status: STATUS.NORMAL, symbols: [], overlays: [], flags: [], reEntryExpiresAt: null },
  { id: 'F18', name: 'F18', type: 'flower', mode: MODES.CROP, stage: 'Flower Day 21', status: STATUS.ALERT,  symbols: [SYMBOLS.ISSUE], overlays: [], flags: [], reEntryExpiresAt: null },
  { id: 'F15', name: 'F15', type: 'flower', mode: MODES.CROP, stage: 'Flower Day 28', status: STATUS.NORMAL, symbols: [SYMBOLS.HARVEST_READY], overlays: [], flags: [], reEntryExpiresAt: null },
  { id: 'F16', name: 'F16', type: 'flower', mode: MODES.CROP, stage: 'Flower Day 35', status: STATUS.NORMAL, symbols: [], overlays: [], flags: [], reEntryExpiresAt: null },
  { id: 'LIVCLONE', name: 'LIVING & CLONING', type: 'support', mode: MODES.CROP, stage: 'Week 3', status: STATUS.NORMAL, symbols: [], overlays: [], flags: [], reEntryExpiresAt: null },
  { id: 'PREVEG',   name: 'PRE-VEG',          type: 'support', mode: MODES.CROP, stage: 'Active', status: STATUS.NORMAL, symbols: [], overlays: [], flags: [], reEntryExpiresAt: null },
  { id: 'PLANTING', name: 'PLANTING',          type: 'support', mode: MODES.CROP, stage: 'Active', status: STATUS.NORMAL, symbols: [], overlays: [], flags: [], reEntryExpiresAt: null },
  { id: 'DRY1', name: 'DRY 1', type: 'utility', mode: MODES.AUTO, stage: 'Curing', status: STATUS.NORMAL, symbols: [], overlays: [], flags: [], reEntryExpiresAt: null },
  { id: 'DRY2', name: 'DRY 2', type: 'utility', mode: MODES.AUTO, stage: 'Curing', status: STATUS.NORMAL, symbols: [], overlays: [], flags: [], reEntryExpiresAt: null },
  { id: 'DRY3', name: 'DRY 3', type: 'utility', mode: MODES.OFF,  stage: 'Empty',  status: STATUS.IDLE,   symbols: [], overlays: [], flags: [], reEntryExpiresAt: null },
  { id: 'DRY4', name: 'DRY 4', type: 'utility', mode: MODES.OFF,  stage: 'Empty',  status: STATUS.IDLE,   symbols: [], overlays: [], flags: [], reEntryExpiresAt: null },
  { id: 'DRY5', name: 'DRY 5', type: 'utility', mode: MODES.AUTO, stage: 'Curing', status: STATUS.NORMAL, symbols: [], overlays: [], flags: [], reEntryExpiresAt: null },
]

// ── Defoliation seed ──────────────────────────────────────────────────────
const makeEmptyTables = () =>
  Array.from({ length: 6 }, (_, i) => ({ id: i, left: false, right: false }))

// ── API helpers ───────────────────────────────────────────────────────────
const API_BASE = import.meta.env.VITE_API_BASE_URL ?? ''

async function apiFetch(path, options = {}) {
  // getToken() awaits stackApp.getUser() so this is race-condition safe
  const token = await getToken()
  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers ?? {}),
    },
  })
  if (!res.ok) {
    const err = await res.json().catch(() => ({}))
    throw Object.assign(new Error(err.error ?? `HTTP ${res.status}`), { status: res.status })
  }
  return res.status === 204 ? null : res.json()
}

// ── Map API room shape → local room shape ─────────────────────────────────
function mapApiRoom(r) {
  const overlays = r.overlays ?? []
  // Merge with initial room data so client-only fields (status, stage) are preserved
  // when the API room row doesn't include them
  const initial  = initialRooms.find(ir => ir.id === r.id) ?? {}
  return {
    ...initial,
    ...r,
    overlays,
    symbols: overlays.filter(o => o.status === 'active').map(o => o.overlayType),
    status:  r.status ?? initial.status ?? STATUS.NORMAL,
  }
}

// ── Normalize a room name for fuzzy matching ───────────────────────────────
// "VEG 1" → "VEG1", "PRE-VEG" → "PREVEG", "Living & Cloning" → "LIVINGCLONING"
function normalizeRoomName(name) {
  return (name ?? '').toUpperCase().replace(/[^A-Z0-9]/g, '')
}

// ── LifeChart → Mission Control room name overrides ────────────────────────
// LC and MC use different naming conventions for the same physical rooms.
// Normalized LC name → MC room id.
const LC_ROOM_OVERRIDES = {
  // Flower rooms: LC "Flower #N" → MC "FN"
  'FLOWER5':  'F5',  'FLOWER6':  'F6',  'FLOWER7':  'F7',  'FLOWER8':  'F8',
  'FLOWER9':  'F9',  'FLOWER10': 'F10', 'FLOWER11': 'F11', 'FLOWER12': 'F12',
  'FLOWER13': 'F13', 'FLOWER14': 'F14', 'FLOWER15': 'F15', 'FLOWER16': 'F16',
  'FLOWER17': 'F17', 'FLOWER18': 'F18',
  // Cure/Dry rooms: LC "Cure #N" → MC "DRYN"
  'CURE1': 'DRY1', 'CURE2': 'DRY2', 'CURE3': 'DRY3', 'CURE4': 'DRY4', 'CURE5': 'DRY5',
}

// ── Store ─────────────────────────────────────────────────────────────────
export const useFacilityStore = create((set, get) => ({
  rooms: initialRooms,
  selectedRoomId: null,
  drawerOpen: false,
  activeTable: null,   // { roomId, tableIndex } | null
  workOrders: {},    // Record<lcRoomId, WorkOrder[]> — open work orders only
  apiStatus: 'offline', // 'loading' | 'online' | 'offline'

  authUser: null,
  setAuthUser: (user) => set({ authUser: user }),

  // ── LifeChart profile + room ID mapping ───────────────────────────────────
  // lcProfile: role, facility_ids, allowed_modes from LC /api/auth/me
  // lcRoomMap: { mcRoomId → lcRoomUUID } — built by matching room names
  // lcRoomMapReady: false while loading, true once map attempt has completed
  lcProfile: null,
  lcRoomMap: {},
  lcRoomMapReady: false,

  resetLcState: () => set({ lcProfile: null, lcRoomMap: {}, lcRoomMapReady: false }),

  loadLcProfile: async (token) => {
    if (!token || !API_BASE) {
      console.warn('[LC] loadLcProfile skipped — no token or API_BASE')
      set({ lcRoomMapReady: true })
      return
    }
    set({ lcRoomMapReady: false })
    console.log('[LC] loadLcProfile — fetching /api/lifechart/me')
    try {
      const res = await fetch(`${API_BASE}/api/lifechart/me`, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      })
      const data = await res.json()
      console.log('[LC] /me HTTP', res.status, '— _lc_ok:', data?._lc_ok, '| error:', data?.error ?? 'none')
      if (!res.ok || !data?._lc_ok) {
        console.warn('[LC] profile rejected — user may not be linked in LifeChart. Set lcRoomMapReady=true to unblock UI.')
        set({ lcRoomMapReady: true })
        return
      }
      const { _lc_ok: _o, _lc_status: _s, ...profile } = data
      console.log('[LC] profile loaded ✓ role:', profile.role, '| facility_ids:', profile.facility_ids)
      set({ lcProfile: profile })
      const facilityIds = profile.facility_ids ?? []
      if (facilityIds.length === 0) {
        console.warn('[LC] no facility_ids on profile — cannot build room map')
        set({ lcRoomMapReady: true })
      } else {
        console.log('[LC] trying all', facilityIds.length, 'facilities to find best room match')
        get().loadLcRoomMap(facilityIds, token)
      }
    } catch (e) {
      console.error('[LC] loadLcProfile threw:', e?.message ?? e)
      set({ lcRoomMapReady: true })
    }
  },

  loadLcRoomMap: async (facilityIds, token) => {
    const ids = Array.isArray(facilityIds) ? facilityIds : [facilityIds]
    if (ids.length === 0 || !API_BASE) {
      set({ lcRoomMapReady: true })
      return
    }
    const mcRooms = get().rooms

    function buildMap(lcRooms) {
      const map = {}
      for (const lcRoom of lcRooms) {
        const lcNorm = normalizeRoomName(lcRoom.name)
        const overrideMcId = LC_ROOM_OVERRIDES[lcNorm]
        if (overrideMcId) { map[overrideMcId] = lcRoom.id; continue }
        const mc = mcRooms.find(r => r.id === lcNorm || normalizeRoomName(r.name) === lcNorm)
        if (mc) map[mc.id] = lcRoom.id
      }
      return map
    }

    try {
      // Fetch all facilities in parallel, pick the one with the most MC matches
      const results = await Promise.all(ids.map(async (id) => {
        console.log('[LC] loadLcRoomMap — fetching rooms for facility:', id)
        try {
          const res = await fetch(`${API_BASE}/api/lifechart/rooms?facility_id=${id}`, {
            headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
          })
          console.log('[LC] rooms HTTP', res.status, 'for facility:', id)
          if (!res.ok) return { facilityId: id, map: {}, count: 0 }
          const lcRooms = await res.json()
          if (!Array.isArray(lcRooms)) return { facilityId: id, map: {}, count: 0 }
          const map = buildMap(lcRooms)
          return { facilityId: id, map, count: Object.keys(map).length }
        } catch {
          return { facilityId: id, map: {}, count: 0 }
        }
      }))

      // Pick best facility (most MC room matches)
      const best = results.reduce((a, b) => b.count > a.count ? b : a, results[0])
      console.log('[LC] room map built — best facility:', best.facilityId, '| matched:', best.count, '| tried:', ids.length)
      set({ lcRoomMap: best.map, lcRoomMapReady: true })
      // Load calendar tasks now that we have room mapping context
      get().loadLcCalendarTasks(token)
    } catch (e) {
      console.error('[LC] loadLcRoomMap threw:', e?.message ?? e)
      set({ lcRoomMapReady: true })
    }
  },

  // ── Tasks (whiteboard + chat-created) ─────────────────────────────────────
  tasks: [],
  hoveredRoomId: null,
  setHoveredRoomId: (id) => set({ hoveredRoomId: id }),
  loadTasks: async () => {
    try {
      const data = await apiFetch('/api/tasks')
      set({ tasks: data })
    } catch (e) {
      console.error('[facility] loadTasks failed:', e)
    }
  },
  addTask:    (task) => set(s => ({ tasks: [task, ...s.tasks.filter(t => t.id !== task.id)] })),
  updateTask: (id, patch) => set(s => ({ tasks: s.tasks.map(t => t.id === id ? { ...t, ...patch } : t) })),
  deleteTask: (id) => set(s => ({ tasks: s.tasks.filter(t => t.id !== id) })),

  // ── LC calendar tasks ─────────────────────────────────────────────────────
  // Flat list of cultivation tasks from all facility rooms with computed dueDates.
  // Populated by loadLcCalendarTasks() once the LC room map is ready.
  lcCalendarTasks: [],
  lcCalendarLoading: false,
  loadLcCalendarTasks: async (token) => {
    if (!API_BASE) return
    set({ lcCalendarLoading: true })
    try {
      const t = token ?? (await import('../lib/apiFetch').then(m => m.getToken()))
      console.log('[LC calendar] fetching — token present:', !!t, '| API_BASE:', API_BASE)
      const res = await fetch(`${API_BASE}/api/lifechart/calendar`, {
        headers: {
          Authorization: `Bearer ${t}`,
          'Content-Type': 'application/json',
        },
      })
      console.log('[LC calendar] HTTP', res.status)
      if (!res.ok) {
        const err = await res.json().catch(() => ({}))
        console.warn('[LC calendar] non-ok response:', err)
        return
      }
      const data = await res.json()
      console.log('[LC calendar] received', Array.isArray(data) ? data.length : 'non-array', 'tasks')
      if (Array.isArray(data) && data.length > 0) {
        console.log('[LC calendar] first task sample:', JSON.stringify(data[0]))
        const dueDates = [...new Set(data.map(t => t.dueDate))].sort()
        console.log('[LC calendar] unique dueDates:', dueDates.slice(0, 10))
      }
      set({ lcCalendarTasks: Array.isArray(data) ? data : [] })
    } catch (e) {
      console.error('[LC] loadLcCalendarTasks failed:', e)
    } finally {
      set({ lcCalendarLoading: false })
    }
  },

  // Overlay visibility filters
  hiddenOverlayTypes: new Set(),
  toggleOverlayFilter: (key) => set(s => {
    const next = new Set(s.hiddenOverlayTypes)
    next.has(key) ? next.delete(key) : next.add(key)
    return { hiddenOverlayTypes: next }
  }),

  // Mobile flag selection
  selectedFlagId: null,

  // Defoliation
  defoliationTables: {
    'F7': [
      { id: 0, left: true,  right: true  },
      { id: 1, left: true,  right: false },
      { id: 2, left: false, right: false },
      { id: 3, left: false, right: false },
      { id: 4, left: false, right: false },
      { id: 5, left: false, right: false },
    ],
  },
  defolInfoRoomId: null,

  // Net log modal
  netLogRoomId: null,

  // PRE-VEG zone batch state
  // zones     — current zone positions (mutable as batch progresses through room)
  // zoneHistory — trail of internal moves [{ fromZones, toZones, movedAt }]
  // destination — planned exit room
  prevegBatches: {
    B78: { zones: [7, 8], zoneHistory: [], destination: null, transferDate: null, notes: '' },
    B56: { zones: [5, 6], zoneHistory: [], destination: null, transferDate: null, notes: '' },
    B3:  { zones: [3],    zoneHistory: [], destination: null, transferDate: null, notes: '' },
    B4:  { zones: [4],    zoneHistory: [], destination: null, transferDate: null, notes: '' },
  },

  // ── Transfers ─────────────────────────────────────────────────────────────
  // { [originId]: { destinationId, transferDate, transferType, notes, createdAt } }
  transfers: {},

  // First step of the two-step transfer assignment
  pendingTransferOrigin: null,

  // WebSocket connections per roomId
  _wsMap: {},

  // ── Load rooms from API ──────────────────────────────────────────────────
  loadRooms: async () => {
    if (!API_BASE) return
    set({ apiStatus: 'loading' })
    try {
      const raw = await apiFetch('/api/rooms')
      const rooms = raw.map(mapApiRoom)
      set({ rooms, apiStatus: 'online' })
      try {
        localStorage.setItem('mtl-rooms-snapshot', JSON.stringify(rooms))
      } catch { /* storage full */ }
    } catch {
      try {
        const snap = localStorage.getItem('mtl-rooms-snapshot')
        if (snap) set({ rooms: JSON.parse(snap).map(mapApiRoom) })
      } catch { /* ignore */ }
      set({ apiStatus: 'offline' })
    }
  },

  loadWorkOrders: async (lcRoomId) => {
    if (!API_BASE || !lcRoomId) return
    try {
      const data = await apiFetch(`/api/lifechart/work-orders?lc_room_id=${lcRoomId}`)
      const orders = Array.isArray(data) ? data : (data.work_orders ?? data.workOrders ?? [])
      set((state) => ({ workOrders: { ...state.workOrders, [lcRoomId]: orders } }))
    } catch { /* non-blocking */ }
  },

  addWorkOrder: async ({ lcRoomId, type, priority, notes }) => {
    if (!API_BASE || !lcRoomId) return null
    const tempId = `temp-${Date.now()}`
    const tempOrder = {
      id: tempId,
      type,
      priority,
      notes,
      status: 'open',
      created_at: new Date().toISOString(),
    }

    set((state) => ({
      workOrders: {
        ...state.workOrders,
        [lcRoomId]: [tempOrder, ...(state.workOrders[lcRoomId] ?? [])],
      },
    }))

    try {
      const order = await apiFetch('/api/lifechart/work-orders', {
        method: 'POST',
        body: JSON.stringify({ lc_room_id: lcRoomId, type, priority, notes }),
      })
      set((state) => ({
        workOrders: {
          ...state.workOrders,
          [lcRoomId]: (state.workOrders[lcRoomId] ?? []).map(o => o.id === tempId ? order : o),
        },
      }))
      return order
    } catch (err) {
      set((state) => ({
        workOrders: {
          ...state.workOrders,
          [lcRoomId]: (state.workOrders[lcRoomId] ?? []).filter(o => o.id !== tempId),
        },
      }))
      throw err
    }
  },

  resolveWorkOrder: async (id, lcRoomId) => {
    if (!API_BASE || !lcRoomId) return

    set((state) => ({
      workOrders: {
        ...state.workOrders,
        [lcRoomId]: (state.workOrders[lcRoomId] ?? []).filter(o => o.id !== id),
      },
    }))

    try {
      await apiFetch(`/api/lifechart/work-orders/${id}`, {
        method: 'PUT',
        body: JSON.stringify({ status: 'resolved' }),
      })
    } catch {
      try {
        const data = await apiFetch(`/api/lifechart/work-orders?lc_room_id=${lcRoomId}`)
        const orders = Array.isArray(data) ? data : (data.work_orders ?? data.workOrders ?? [])
        set((state) => ({ workOrders: { ...state.workOrders, [lcRoomId]: orders } }))
      } catch { /* offline — leave optimistic state */ }
    }
  },

  // ── Connect WebSocket to room Durable Object ─────────────────────────────
  connectRoomWs: (roomId) => {
    if (!API_BASE) return
    const { _wsMap } = get()
    if (_wsMap[roomId]) return // already connected

    const wsUrl = API_BASE.replace(/^http/, 'ws') + `/ws/rooms/${roomId}`
    const ws = new WebSocket(wsUrl)

    ws.onmessage = (evt) => {
      try {
        const msg = JSON.parse(evt.data)
        if (msg.type === 'ROOM_UPDATED' && msg.room) {
          const updated = mapApiRoom(msg.room)
          set((state) => ({
            rooms: state.rooms.map((r) => (r.id === updated.id ? { ...r, ...updated } : r)),
          }))
        }
      } catch { /* ignore bad frames */ }
    }

    ws.onclose = () => {
      set((state) => {
        const m = { ...state._wsMap }
        delete m[roomId]
        return { _wsMap: m }
      })
      setTimeout(() => get().connectRoomWs(roomId), 3000)
    }

    set((state) => ({ _wsMap: { ...state._wsMap, [roomId]: ws } }))
  },

  // ── UI actions ──────────────────────────────────────────────────────────
  openDefolInfo:  (roomId) => set({ defolInfoRoomId: roomId }),
  closeDefolInfo: ()       => set({ defolInfoRoomId: null }),
  openNetLog:     (roomId) => set({ netLogRoomId: roomId }),
  closeNetLog:    ()       => set({ netLogRoomId: null }),

  setPrevegBatch: (batchId, data) =>
    set(state => ({
      prevegBatches: {
        ...state.prevegBatches,
        [batchId]: { ...state.prevegBatches[batchId], ...data },
      },
    })),

  clearPrevegBatch: (batchId) =>
    set(state => ({
      prevegBatches: {
        ...state.prevegBatches,
        [batchId]: { ...state.prevegBatches[batchId], destination: null, transferDate: null, notes: '' },
      },
    })),

  // Move a batch to different zones within PreVeg.
  // If the target is occupied by another batch, the two swap positions.
  movePrevegBatch: (batchId, toZones) =>
    set(state => {
      const batch = state.prevegBatches[batchId]
      if (!batch) return state
      const toKey   = [...toZones].sort().join()
      const fromKey = [...batch.zones].sort().join()
      if (toKey === fromKey) return state

      const now       = new Date().toISOString()
      const fromZones = batch.zones
      const updated   = { ...state.prevegBatches }

      // Move the requested batch
      updated[batchId] = {
        ...batch,
        zones: toZones,
        zoneHistory: [...batch.zoneHistory, { fromZones, toZones, movedAt: now }],
      }

      // If another batch occupies the target, swap it back to fromZones
      const swapId = Object.keys(updated).find(id => {
        if (id === batchId) return false
        return [...(state.prevegBatches[id]?.zones ?? [])].sort().join() === toKey
      })
      if (swapId) {
        const swapBatch = state.prevegBatches[swapId]
        updated[swapId] = {
          ...swapBatch,
          zones: fromZones,
          zoneHistory: [
            ...swapBatch.zoneHistory,
            { fromZones: toZones, toZones: fromZones, movedAt: now },
          ],
        }
      }

      return { prevegBatches: updated }
    }),

  // Undo the last internal zone move for a batch
  undoPrevegBatchMove: (batchId) =>
    set(state => {
      const batch = state.prevegBatches[batchId]
      if (!batch?.zoneHistory?.length) return state
      const history = [...batch.zoneHistory]
      const last = history.pop()
      return {
        prevegBatches: {
          ...state.prevegBatches,
          [batchId]: { ...batch, zones: last.fromZones, zoneHistory: history },
        },
      }
    }),
  selectRoom:     (roomId) => set({ selectedRoomId: roomId, drawerOpen: true }),
  closeDrawer:    ()       => set({ selectedRoomId: null, drawerOpen: false, activeTable: null }),
  setActiveTable:   (roomId, tableIndex) => set({ activeTable: { roomId, tableIndex } }),
  clearActiveTable: () => set({ activeTable: null }),
  getRoom:        (roomId) => get().rooms.find(r => r.id === roomId),

  // Mobile: select a flag type for tap-to-assign
  selectFlag: (flagId) => set((state) => ({
    selectedFlagId: state.selectedFlagId === flagId ? null : flagId,
  })),
  clearSelectedFlag: () => set({ selectedFlagId: null }),

  // ── Room mode ────────────────────────────────────────────────────────────
  updateRoomMode: async (roomId, mode) => {
    set((state) => ({
      rooms: state.rooms.map(r => r.id === roomId ? { ...r, mode } : r),
    }))
    try {
      await apiFetch(`/api/rooms/${roomId}`, {
        method: 'PATCH',
        body: JSON.stringify({ mode }),
      })
    } catch {
      // Revert on failure — handled by WS broadcast on next reconnect
    }
  },

  // ── Overlay actions (API-backed) ─────────────────────────────────────────
  placeOverlay: async (roomId, overlayType, options = {}) => {
    const tempId = `temp-${Date.now()}`
    const tempOverlay = { id: tempId, roomId, overlayType, options, status: 'active' }

    // Optimistic update
    set((state) => ({
      rooms: state.rooms.map(r => {
        if (r.id !== roomId) return r
        const overlays = [...(r.overlays ?? []), tempOverlay]
        return {
          ...r,
          overlays,
          symbols: overlays.filter(o => o.status === 'active').map(o => o.overlayType),
        }
      }),
    }))

    if (!API_BASE) return
    try {
      const overlay = await apiFetch(`/api/rooms/${roomId}/overlays`, {
        method: 'POST',
        body: JSON.stringify({ overlayType, options }),
      })
      // Replace temp with real overlay from server
      set((state) => ({
        rooms: state.rooms.map(r => {
          if (r.id !== roomId) return r
          const overlays = r.overlays.map(o => o.id === tempId ? overlay : o)
          return {
            ...r,
            overlays,
            symbols: overlays.filter(o => o.status === 'active').map(o => o.overlayType),
          }
        }),
      }))
    } catch { /* offline — optimistic state stays */ }
  },

  removeOverlay: async (roomId, overlayType) => {
    const room = get().rooms.find(r => r.id === roomId)
    const overlay = room?.overlays?.find(o => o.overlayType === overlayType && o.status === 'active')

    // Optimistic update
    set((state) => ({
      rooms: state.rooms.map(r => {
        if (r.id !== roomId) return r
        const overlays = r.overlays.filter(o => !(o.overlayType === overlayType && o.status === 'active'))
        return {
          ...r,
          overlays,
          symbols: overlays.filter(o => o.status === 'active').map(o => o.overlayType),
        }
      }),
    }))

    if (!overlay || !API_BASE) return
    try {
      await apiFetch(`/api/rooms/${roomId}/overlays/${overlay.id}`, { method: 'DELETE' })
    } catch { /* offline */ }
  },

  // ── Flags (symbols) — now backed by the overlays API ─────────────────────
  addSymbolToRoom: async (roomId, symbol) => {
    return get().placeOverlay(roomId, symbol)
  },

  removeSymbolFromRoom: async (roomId, symbol) => {
    return get().removeOverlay(roomId, symbol)
  },

  // ── Re-entry countdown ──────────────────────────────────────────────────
  clearReEntry: (roomId) =>
    set((state) => ({
      rooms: state.rooms.map(r =>
        r.id === roomId ? { ...r, reEntryExpiresAt: null } : r
      ),
    })),

  // ── Status (legacy — kept for existing map rendering) ────────────────────
  updateRoomStatus: (roomId, status) =>
    set(state => ({
      rooms: state.rooms.map(r => r.id === roomId ? { ...r, status } : r),
    })),

  // ── Transfer actions ──────────────────────────────────────────────────────
  startTransfer: (originRoomId) => {
    set((state) => ({
      pendingTransferOrigin: originRoomId,
      rooms: state.rooms.map(r =>
        r.id === originRoomId && !r.symbols.includes(SYMBOLS.TRANSFER)
          ? { ...r, symbols: [...r.symbols, SYMBOLS.TRANSFER] }
          : r
      ),
    }))
  },

  completeTransfer: (destinationRoomId) => {
    const { pendingTransferOrigin } = get()
    if (!pendingTransferOrigin || pendingTransferOrigin === destinationRoomId) return

    set((state) => ({
      pendingTransferOrigin: null,
      transfers: {
        ...state.transfers,
        [pendingTransferOrigin]: {
          destinationId: destinationRoomId,
          transferDate: null,
          transferType: 'transplant',
          notes: '',
          createdAt: new Date().toISOString(),
        },
      },
    }))
  },

  cancelTransfer: () => {
    const { pendingTransferOrigin } = get()
    if (!pendingTransferOrigin) return
    set((state) => ({
      pendingTransferOrigin: null,
      rooms: state.rooms.map(r =>
        r.id === pendingTransferOrigin
          ? { ...r, symbols: r.symbols.filter(s => s !== SYMBOLS.TRANSFER) }
          : r
      ),
    }))
  },

  updateTransfer: (originRoomId, data) =>
    set((state) => ({
      transfers: {
        ...state.transfers,
        [originRoomId]: { ...state.transfers[originRoomId], ...data },
      },
    })),

  removeTransfer: (originRoomId) =>
    set((state) => {
      const transfers = { ...state.transfers }
      delete transfers[originRoomId]
      return {
        transfers,
        rooms: state.rooms.map(r =>
          r.id === originRoomId
            ? { ...r, symbols: r.symbols.filter(s => s !== SYMBOLS.TRANSFER) }
            : r
        ),
      }
    }),

  // ── Defoliation ──────────────────────────────────────────────────────────
  toggleDefolHalf: (roomId, tableId, half) =>
    set(state => {
      const current = state.defoliationTables[roomId] ?? makeEmptyTables()
      return {
        defoliationTables: {
          ...state.defoliationTables,
          [roomId]: current.map(t =>
            t.id === tableId ? { ...t, [half]: !t[half] } : t
          ),
        },
      }
    }),
}))
